export const defaultSelectComponentStyles = {
  control: (base, { isFocused }) => ({
    ...base,
    borderColor: "#d1d5db",
    borderRadius: "0.375rem",
    boxShadow: isFocused ? `0 0 0 1px #9ca3af` : 0,
    minHeight: "3rem",
    "&:hover": {
      borderColor: isFocused ? "#d1d5db" : base.borderColor,
    },
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? "#f3f4f6" : undefined,
    ":active": {
      ...base[":active"],
      backgroundColor: "#f3f4f6",
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: "#9ca3af",
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
  }),
};
